import './ClubCard.scss'

import Avatar from '../../Avatar/Avatar'
import Button from '../../../components/Button/Button'
import Icon from '../../../components/Icon/Icon'
import PropTypes from 'prop-types'
import React from 'react'
import t from '../../../helpers/i18n'

export const ClubCard = ({
  clubName,
  sportSubtypes,
  ownerName,
  clubType,
  ownerNumberPhone,
  onClick
}) => {
  return (
    <div className='storybook-card-club'>
      <div className='-storybook-main-container'>
        <div className='-storybook-container'>
          <div className='-menu'>
            <input type='checkbox' className='-checkbox' />
            <div className='-divider'></div>
            <Icon size={14} icon='ArchiveIcon' />
            <Icon size={16} icon='MoreIcon' />
          </div>
          <div className='-club-name proper-noun-large-semibold'>
            {clubName}
          </div>
          <div className='-sport-subtype overline-label-small-basic'>
            {sportSubtypes.map((subtype) => (
              <span>{subtype}</span>
            ))}
          </div>
        </div>
        <div className='-logo-club-temporal'>
          <Avatar size="large" alternative="Club Logo"  />
        </div>
      </div>

      <div className='-description'>
        <div className='-description-data-container'>
          <div className='-data-row'>
            <div className='-label label-small-basic'>{t('labels.Type')}</div>
            <div className='-type label-small-medium'>{clubType}</div>
          </div>
          <div className='-data-row'>
            <div className='-label label-small-basic'>{t('labels.Owner')}</div>
            <div className='-name proper-noun-small-medium'>
              <span>{ownerName}</span>
              <div className='-owner-image-temporal'>
                <Avatar size="small" alternative="Owner Logo"  />
              </div>
            </div>
          </div>
          <div className='-data-row'>
            <div className='-label label-small-basic'>{t('labels.Mobile_number')}</div>
            <div className='-phone label-small-medium'>{ownerNumberPhone}</div>
          </div>
        </div>

        <div className='-data-container'>
          <button className='-data'>
            <Icon size={16} icon='AttachmentIcon' />
            <span className='-number label-small-medium'>5</span>
          </button>
          <div className='-divider'></div>
          <button className='-data'>
            <span className='-number label-small-medium'>4</span>
            <span className='-label label-small-basic'>{t('buttons.teams')}</span>
          </button>
          <button className='-data'>
            <span className='-number label-small-medium'>317</span>
            <span className='-label label-small-basic'>{t('buttons.players')}</span>
          </button>
          <button className='-data'>
            <span className='-number label-small-medium'>8</span>
            <span className='-label label-small-basic'>{t('buttons.delegates')}</span>
          </button>
          <button className='-data'>
            <span className='-number label-small-medium'>38</span>
            <span className='-label label-small-basic'>{t('buttons.technical_staff')}</span>
          </button>
          <div className='-right-fade'></div>
        </div>
      </div>

      <div className='-btn'>
        <Button
          size='field-sized'
          type='light'
          color='green'
          label={t('buttons.Open_full_profile')}
          icon='ArrowRightIcon'
          iconPosition='trailing'
          onClick={onClick}
        />
      </div>
    </div>
  )
}

ClubCard.propTypes = {
  clubName: PropTypes.string,
  sportSubtypes: PropTypes.array,
  clubType: PropTypes.string,
  ownerName: PropTypes.string,
  ownerNumberPhone: PropTypes.string,
  onClick: PropTypes.func
}

ClubCard.defaultProps = {
  clubName: 'YERNOS DE PARRA FC',
  sportSubtypes: ['SOCCER', 'FUTSAL'],
  clubType: 'Family Club',
  ownerName: 'JAVIER PARRA',
  ownerNumberPhone: '51 (33) 1600 2653',
  onClick: undefined
}
